import React from "react";
import { Sparkles } from "lucide-react";

function ZeroState({ searchQuery, setSearchQuery, menuType, onClear }) {
  return (
    <div className="zero-result-state">
      <Sparkles size={42} color="var(--gold)" />
      <h3>No items found</h3>
      <p>
        We couldn't find anything matching <strong>"{searchQuery}"</strong> in{" "}
        {menuType === "food" ? "Food Menu" : "Drinks Menu"}.
      </p>
      <div className="search-suggestions">
        <span>Try searching for:</span>
        <div className="suggestion-pills">
          {menuType === "food" ? (
            <>
              <button onClick={() => setSearchQuery("Tandoor")}>Tandoor</button>
              <button onClick={() => setSearchQuery("Chilli")}>Chilli</button>
              <button onClick={() => setSearchQuery("Ghee")}>Ghee Roast</button>
              <button onClick={() => setSearchQuery("Paneer")}>Paneer</button>
            </>
          ) : (
            <>
              <button onClick={() => setSearchQuery("Margarita")}>Margarita</button>
              <button onClick={() => setSearchQuery("Sula")}>Sula Wine</button>
              <button onClick={() => setSearchQuery("Whisky")}>Whisky</button>
              <button onClick={() => setSearchQuery("Single Malt")}>Single Malt</button>
            </>
          )}
        </div>
      </div>
      <button className="gold-btn clear-filters-btn" onClick={onClear}>
        Clear All Filters
      </button>
    </div>
  );
}

export default React.memo(ZeroState);
